import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import LogoutIcon from '@mui/icons-material/Logout';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { BottomNavigation, BottomNavigationAction, Box, Divider, Drawer, Grid, IconButton, InputAdornment, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, TextField, Tooltip, Typography, useMediaQuery, Badge } from '@mui/material';
import React, { useContext, useEffect, useState, useCallback, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { default as Image, default as Images } from '../../Assets/assetHelper';
import KenAvatar from '../../GlobalComponents/KenAvatar';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { useSearchContext } from '../../Helpers/Contexts/searchContext';
import routes from '../../Utils/routes';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import MobileSideNav from './MobileSideNav';
import NotificationDialog from './NotificationDialog';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
// import  LogoIcon from '../../../Assets/Icons/logo.png';
import LogoIcon from '../../../src/Assets/Icons/logo2.png';
import storageService from '../../Utils/storageService';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const { dispatch } = useContext(AuthContext);
  const { searchTerm, setSearchTerm } = useSearchContext();
  const navigate = useHistory();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery('(max-width:1000px)');

  const [hideSideBar, setHideSideBar] = useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [userData, setUserData] = useState<AuthUser | null>(null);
  // const [loading] = useState(true); // Removed unused variable
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [notificationCount, setNotificationCount] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const previousPathRef = useRef<string>(pathname);

  // Check if current page is deals page or startups page
  const isDealsPage = pathname.includes('/deals') || pathname.includes('/offers');
  const isStartupsPage = pathname.includes('/startups');
  const showSearchInHeader = isDealsPage || isStartupsPage;
  
  // Check if current page is venue booking page
  const isVenueBookingPage = pathname.includes('/facilities') || 
                            pathname.includes('/meeting rooms') || 
                            pathname.includes('/facilityDetails') || 
                            pathname.includes('/book facility') || 
                            pathname.includes('/cart') || 
                            pathname.includes('/billing details') || 
                            pathname.includes('/bookings') || 
                            pathname.includes('/transactions') || 
                            pathname.includes('/calendar') || 
                            (pathname.includes('/my profile') && pathname !== routes.profile);

  // Check if user is in guest mode
const [selectedRole, setSelectedRole] = useState<string>('');
  const isGuestMode = selectedRole==='Guest';
  
  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      setSearchTerm(localSearchTerm);
    }, 300);

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [localSearchTerm, setSearchTerm]);

  // Sync local search term with context search term when context changes externally
  useEffect(() => {
    setLocalSearchTerm(searchTerm);
  }, [searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setLocalSearchTerm(value);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const toggleDrawer = (open: boolean | ((prevState: boolean) => boolean)) => () => {
    setIsDrawerOpen(open);
  };

  const handleOpenClickOpenNotification = () => {
    setOpenNotification(true);
  };

  const handleCloseNotificationDialog = () => {
    setOpenNotification(false);
  };

  // Callback to update notification count when notifications are marked as read
  const handleNotificationCountUpdate = (newCount: number) => {
    setNotificationCount(Math.max(0, newCount));
  };

  const fetchNotificationCount = useCallback(async () => {
    try {
      const userid = userData?.applicantId;
      if (userid) {
        // Import the function from apiService
        const { getUnreadNotificationCount } = await import('../../Utils/apiService');
        const count = await getUnreadNotificationCount(userid);
        setNotificationCount(Math.max(0, count));
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
      setNotificationCount(0);
    }
  }, [userData?.applicantId]);
  useEffect(() => {
    const initializeUserData = async () => {
      try {
        const isGuest = await storageService.getItem('role') as unknown as { roleType: string };
        console.log(isGuest,'isGuest');
        const user = await storageService.getItem('user') as AuthUser;
        setUserData(user);
        if(isGuest?.roleType==='guest'){
          setSelectedRole('Guest');
        }
        else{
          const selectedRole = await storageService.getItem('preferences') as unknown as string;
          setSelectedRole(selectedRole?.[0] || '');
        }
      
      } catch (error) {
        console.error('Error loading user data:', error);
      }
    };

    initializeUserData();
  }, []);

  const handleListClick = (path: string, index: number) => {
    navigate.push(path);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleMenuClick = (route: string) => {
    navigate.push(route);
    handleClose();
  };

  useEffect(() => {
    setHideSideBar(isMobile);
  }, [isMobile]);

  // Fetch notification count on component mount and periodically
  // useEffect(() => {
  //   if (userData?.applicantId) {
  //     fetchNotificationCount();
  //     const interval = setInterval(fetchNotificationCount, 100000); // Fetch every 100 seconds
  //     return () => clearInterval(interval);
  //   }
  // }, [userData?.applicantId, fetchNotificationCount]);

  // Clear search term when leaving pages that use search
  useEffect(() => {
    const currentUsesSearch = isDealsPage || isStartupsPage;
    const previousPath = previousPathRef.current;
    const hasPathChanged = previousPath !== pathname;
    
    // Only clear search term when actually navigating away from search-enabled pages
    if (hasPathChanged && !currentUsesSearch) {
      setSearchTerm('');
      setLocalSearchTerm('');
    }
    
    // Update the previous path reference
    previousPathRef.current = pathname;
  }, [pathname, isDealsPage, isStartupsPage, setSearchTerm]);

  // Fetch venue booking cart count when on venue booking pages
  useEffect(() => {
    const fetchCartCount = async () => {
      if (isVenueBookingPage && userData?.applicantId) {
        try {
          // Dynamically import getBookings function and calculateCartCount from venue portal services
          const { getBookings } = await import('../../Containers/VenuePortal/src/utils/services');
          const { calculateCartCount } = await import('../../Containers/VenuePortal/src/utils/helpers');
          const res = await getBookings();
          
          if (res.data.status === 'true') {
            const count = calculateCartCount(res.data.result || []);
            setCartCount(count);
          }
        } catch (error) {
          console.error('Error fetching cart count:', error);
          setCartCount(0);
        }
      } else {
        setCartCount(0);
      }
    };

    fetchCartCount();
  }, [pathname, userData?.applicantId, isVenueBookingPage]);

  const handleNavigation = (newValue: number) => {
    setValue(newValue);
    navigate.push(menuItems[newValue].route);
  };

  const menuItems = [
    { name: 'Events', filledIcon: <AutoAwesomeIcon className={classes.icon} />, outlinedIcon: <AutoAwesomeOutlinedIcon className={classes.icon} />, route: routes.events },
    { name: 'Global Portfolio', filledIcon: <GroupsIcon className={classes.icon} />, outlinedIcon: <GroupsOutlinedIcon className={classes.icon} />, route: routes.startups },
    { name: 'Home', filledIcon: <HomeIcon className={classes.icon} />, outlinedIcon: <HomeOutlinedIcon className={classes.icon} />, route: routes.home },
    { name: 'Deals & Offers', filledIcon: <AnalyticsIcon className={classes.icon} />, outlinedIcon: <AnalyticsOutlinedIcon className={classes.icon} />, route: routes.deals },
    { name: 'Profile', filledIcon: <AccountCircleIcon className={classes.icon} />, outlinedIcon: <AccountCircleOutlinedIcon className={classes.icon} />, route: routes.profile },
  ];

  return (
    <>
      {isMobile ? (
        <>
          <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
            <Box sx={{ pt: '50px', width: '300px', height: '100%',p: '16px',backgroundColor: '#2D2146' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'start',
                  justifyContent: 'space-between',
                  // borderBottom: '1px solid #F0EDF6',
                  // pb: '32px', my: '32px'
                  height: '130px',
                }}
              >
                <Box 
                  onClick={!isGuestMode ? () => navigate.push(routes.profile) : undefined} 
                  
                  sx={{ 
                    cursor: !isGuestMode ? 'pointer' : 'default',
                    opacity: isGuestMode ? 0.7 : 1 
                  }}
                >
                  <KenAvatar classes={classes.avatar3} src={userData?.contactImage ? userData?.contactImage : Images.Images.DefaultProfileImage} />
                  <Typography className={classes.menuTitle}>{userData?.applicantName}</Typography>
                </Box>
                <Box>
                  <IconButton sx={{ p: '0px' }} onClick={toggleDrawer(false)}>
                    <CloseIcon sx={{ color: '#545454', fontSize: '24px' }} id="main-content" />
                  </IconButton>
                </Box>
                
              </Box>
               {/* Switch Profile Button - Hide for guest users */}
              {!isGuestMode && (
                <Box sx={{ width: '100%', borderBottom: '1px solid #F0EDF6' }}>
                  <ListItemButton
                    className={classes.menuListItemButton}
                    onClick={() => {
                      navigate.push(routes.preference);
                      toggleDrawer(false)();
                    }}
                    sx={{
                      backgroundColor: '#F0EDF6',
                      borderRadius: '8px',
                      mb: '8px',
                      '&:hover': {
                        backgroundColor: '#E6E0F7',
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: '40px' }}>
                      <SwapHorizIcon sx={{ color: '#2D2146' }} />
                    </ListItemIcon>
                    <Typography sx={{ color: '#2D2146', fontWeight: '500' }}>
                      Switch Profile
                    </Typography>
                  </ListItemButton>
                </Box>
              )}
             
              <Box sx={{ height: 'calc(100% - 200px)', width: '100%', minHeight: '300px', display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ flex: 1, width: '100%', height: '90%', overflow: 'auto' }}>
                  <MobileSideNav handleListClick={handleListClick} onClose={toggleDrawer(false)} />
                </Box>
                <Box sx={{ mb: '0px', width: '100%', borderTop: '1px solid #8871B8' }}>
                  <ListItemButton
                    className={classes.menuListItemButton}
                    onClick={async () => {
                      dispatch({ type: 'LOGOUT' });
                      await storageService.clear();
                      navigate.push(routes.login);
                    }}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#8871B8 !important',
                      }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                      <LogoutIcon className={classes.menuListItemIcon} />
                    </ListItemIcon>

                    <Typography sx={{ pl: '20px' }} className={classes.menuListItemText}>
                      Logout
                    </Typography>
                  </ListItemButton>
                </Box>
              </Box>
            </Box>
          </Drawer>
          <Box sx={{ height: !isGuestMode ? '93vh' : '100vh', overflow: 'hidden', background: '#FFF' }}>
            <Box sx={{ borderBottom: '1px solid #F0EDF6', height: '8%' }}>
              <Box className={classes.header} style={{ boxShadow: 'none' }}>
                <Box className={classes.mobileHeaderContainer}>
                  {/* Show back arrow and search bar when on deals page or startups page */}
                  {showSearchInHeader ? (
                    <>
                      <IconButton aria-label="back" onClick={() => navigate.goBack()}>
                        <Box 
                          component="svg" 
                          sx={{ width: '24px', height: '24px', color: '#333' }}
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                        </Box>
                      </IconButton>
                      
                      <Box sx={{ flex: 1, mx: 2 }}>
                        <TextField
                          fullWidth
                          placeholder={isStartupsPage ? "Search startups..." : "Search"}
                          value={localSearchTerm}
                          onChange={(e) => {
                            handleSearchChange(e.target.value);
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon sx={{ color: '#999999', fontSize: '18px' }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '16px',
                              backgroundColor: '#F5F5F5',
                              height: '32px',
                              fontSize: '14px',
                              '& fieldset': {
                                borderColor: 'transparent',
                                border: 'none',
                              },
                              '&:hover fieldset': {
                                borderColor: 'transparent',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: 'transparent',
                              },
                            },
                            '& .MuiInputBase-input': {
                              padding: '6px 8px',
                              fontSize: '14px',
                              '&::placeholder': {
                                color: '#999999',
                                opacity: 1,
                              },
                            },
                          }}
                        />
                      </Box>
                      
                      <Box sx={{ display: 'flex', gap: '8px' }}>
                        {/* Add cart icon for venue booking pages */}
                        {isVenueBookingPage && (
                          <IconButton onClick={() => navigate.push(routes.facilitiesCart)}>
                            <Badge badgeContent={cartCount} color="error" sx={{
                              '& .MuiBadge-badge': {
                                background: '#604797',
                                color: '#fff'
                              }
                            }}>
                              <ShoppingCartOutlinedIcon sx={{ fontSize: '24px', color: '#333' }} />
                            </Badge>
                          </IconButton>
                        )}
                        <IconButton onClick={() => navigate.push(routes.notifcation)}>
                          <Badge badgeContent={notificationCount} color="error">
                            <Box 
                              component="svg" 
                              sx={{ width: '24px', height: '24px', color: '#333' }}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                            </Box>
                          </Badge>
                        </IconButton>
                        <IconButton onClick={() => navigate.push(routes.chat)}>
                          <Box 
                            component="svg" 
                            sx={{ width: '24px', height: '24px', color: '#333' }}
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
                          </Box>
                        </IconButton>
                      </Box>
                    </>
                  ) : (
                    <>
                      <IconButton aria-label="menu" onClick={toggleDrawer(true)}>
                        <KenAvatar classes={classes.avatar2} src={userData?.contactImage ? userData?.contactImage : Images.Images.DefaultProfileImage} />{' '}
                      </IconButton>
                      <Box>
                        <AppBreadCrumbs />
                      </Box>
                      <Box sx={{ gap: '10px' }}>
                        {/* Add cart icon for venue booking pages */}
                        {isVenueBookingPage && (
                          <IconButton onClick={() => navigate.push(routes.facilitiesCart)}>
                            <Badge badgeContent={cartCount} color="error" sx={{
                              '& .MuiBadge-badge': {
                                background: '#604797',
                                color: '#fff'
                              }
                            }}>
                              <ShoppingCartOutlinedIcon sx={{ fontSize: '20px', color: '#604797' }} />
                            </Badge>
                          </IconButton>
                        )}
                        <IconButton onClick={() => navigate.push(routes.notifcation)}>
                          <Badge badgeContent={notificationCount} color="error">
                            <img src={Images.Icons.notificationIcon} alt="" />
                          </Badge>
                        </IconButton>
                        <IconButton sx={{ background: '#F0EDF6' }} onClick={() => navigate.push(routes.chat)}>
                          <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: '16px', color: '#604797' }} />
                        </IconButton>
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            <Box sx={{ background: '#FFF', height: '92%', overflow: 'auto' }}>
              <Box sx={{ m: '10px 16px ' }}>{children}</Box>
            </Box>
          </Box>
          {!isGuestMode && (
            <Box style={{ height: '7vh' }}>
              <BottomNavigation 
                value={value} 
                onChange={(event, newValue) => handleNavigation(newValue)} 
                showLabels 
                className={classes.footerNav}
                sx={{
                  '& .MuiBottomNavigation-root': {
                    justifyContent: 'space-around',
                  },
                }}
              >
                {menuItems.map((item, index) => (
                  <BottomNavigationAction
                    key={index}
                    label={pathname.endsWith(item.route) ? item.name : ''}
                    icon={pathname.endsWith(item.route) ? item.filledIcon : item.outlinedIcon}
                    sx={{
                      minWidth: 0,
                      flex: 1,
                      maxWidth: '100%',
                      transition: 'all 0.2s ease-in-out',
                      '& .MuiBottomNavigationAction-label': {
                        fontSize: '10px',
                        fontWeight: '600',
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: '#604797',
                        marginTop: '2px',
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: pathname.endsWith(item.route) ? '22px' : '20px',
                        color: pathname.endsWith(item.route) ? '#604797' : '#8A8A8A',
                        marginBottom: pathname.endsWith(item.route) ? '2px' : '4px',
                        transition: 'all 0.2s ease-in-out',
                      },
                      '&.Mui-selected': {
                        '& .MuiBottomNavigationAction-label': {
                          color: '#604797',
                        },
                        '& .MuiSvgIcon-root': {
                          color: '#604797',
                          fontSize: '22px',
                        },
                      },
                      paddingTop: '6px',
                      paddingBottom: '6px',
                    }}
                  />
                ))}
              </BottomNavigation>
            </Box>
          )}
        </>
      ) : (
        <>
          <Box
            sx={{
              height: '100vh',
              width: '100vw',
              backgroundColor: '#F6F8FB',
            }}
          >
            <Grid container className={classes.mainContainer}>
              <Grid
                item
                xs={hideSideBar ? 1 : 2}
                sm={hideSideBar ? 0.5 : 2}
                md={hideSideBar ? 0.7 : 2}
                lg={hideSideBar ? 0.8 : 2}
                xl={hideSideBar ? 0.8 : 2}
                xxl={hideSideBar ? 0.6 : 2}
                fullHD={hideSideBar ? 0.5 : 2}
                ultraHD={hideSideBar ? 0.4 : 2}
                className={`sidebar scrollbar-cus ${hideSideBar ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
              >
                <Paper className={`${classes.sideBarContainer}`}>
                  <Box className={classes.logoContainer}>
                    {!hideSideBar && (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '12px', ultraHD: '12px' }, userSelect: 'none', width: "100%" }}>
                        <img src={LogoIcon} alt="logo" className={classes.logo} onClick={() => navigate.push(routes.home)} />
                        {/* <Typography className={classes.logoTitle} sx={{ color: '#E6E6E6', fontSize: '32px !important' }}>
                          infive
                        </Typography> */}
                      </Box>
                    )}
                    <Box>
                      <IconButton
                        onClick={() => {
                          if (!isMobile) {
                            setHideSideBar(!hideSideBar);
                          }
                        }}
                      >
                        {hideSideBar ? <KeyboardDoubleArrowRightIcon className={classes.sideBarIcon} /> : <KeyboardDoubleArrowLeftIcon className={classes.sideBarIcon} />}
                      </IconButton>
                    </Box>
                  </Box>
                  <Box className={`${classes.sideBarSubContainer} scrollbar-cus`} sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 120px)' }}>
                    <Box className={`${classes.sideBarSubContainer1} scrollbar-cus`} sx={{ flex: 1, overflowY: 'auto' }}>
                      <SideNavTabs handleListClick={handleListClick} hideSideBar={hideSideBar} />
                    </Box>
                    <Box sx={{ mt: 'auto', mb: { xs: '24px', ultraHD: '42px' } }}>
                      <ListItemButton
                        className={classes.listItemButton}
                        onClick={async () => {
                          dispatch({ type: 'LOGOUT' });
                          await storageService.clear();
                          navigate.push(routes.login);
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: { xs: '2px', lg: '40px' } }}>
                          <LogoutIcon className={classes.listItemIcon} />
                        </ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            className={classes.listItemText}
                            sx={{
                              display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                            }}
                          >
                            Logout
                          </ListItemText>
                        )}
                      </ListItemButton>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid
                item
                xs={hideSideBar ? 11 : 10}
                sm={hideSideBar ? 11.5 : 10}
                md={hideSideBar ? 11.3 : 10}
                lg={hideSideBar ? 11.2 : 10}
                xl={hideSideBar ? 11.2 : 10}
                xxl={hideSideBar ? 11.4 : 10}
                fullHD={hideSideBar ? 11.5 : 10}
                ultraHD={hideSideBar ? 11.6 : 10}
                className={`sidebar`}
              >
                <Box className={classes.headerContainer}>
                  <Box>
                    <Paper className={classes.header} sx={{ borderRadius: '16px !important', background: '#f5f8fb' }}>
                      {hideSideBar && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: '6px', ultraHD: '8px' }, userSelect: 'none' }}>
                          <img src={LogoIcon} alt="logo" className={classes.logo} onClick={() => navigate.push(routes.home)} />
                          {/* <Typography className={classes.logoTitle} sx={{ color: '#604797' }}>
                            Kennovate
                          </Typography> */}
                        </Box>
                      )}
                      <Box>
                        <AppBreadCrumbs />
                      </Box>
                    </Paper>
                  </Box>
                  <Box>
                    <Paper className={classes.actions}>
                      {/* Add cart icon for venue booking pages */}
                      {isVenueBookingPage && (
                        <Tooltip title="Cart">
                          <IconButton sx={{ marginRight: { xs: '1px', lg: '10px', xl: '2px' } }} onClick={() => navigate.push(routes.facilitiesCart)}>
                            <Badge badgeContent={cartCount} color="error" sx={{
                              '& .MuiBadge-badge': {
                                background: '#604797',
                                color: '#fff'
                              }
                            }}>
                              <ShoppingCartOutlinedIcon sx={{ fontSize: { md: '18px', xl: '18px', xxl: '18px', fullHD: '18px', ultraHD: '24px' } }} />
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      )}
                      
                      <Tooltip title="Notifications">
                        <IconButton sx={{ marginRight: { xs: '1px', lg: '10px', xl: '2px' } }} onClick={handleOpenClickOpenNotification}>
                          <Badge badgeContent={notificationCount} color="error">
                            <NotificationsNoneOutlinedIcon sx={{ fontSize: { md: '18px', xl: '18px', xxl: '18px', fullHD: '18px', ultraHD: '24px' } }} />
                          </Badge>
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={isGuestMode ? "Guest user" : "Profile"}>
                        <span>
                          <IconButton 
                            sx={{ p: '0' }} 
                            onClick={handleClick}
                            disabled={isGuestMode}
                          >
                            <KenAvatar classes={classes.avatar} src={userData?.contactImage ? userData?.contactImage : Image.Images.DefaultProfileImage} />
                          </IconButton>
                        </span>
                      </Tooltip>
                        {!isGuestMode && (
                          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                            <MenuItem onClick={() => handleMenuClick(routes.profile)}>Profile</MenuItem>
                            <MenuItem onClick={() => handleMenuClick(routes.preference)}>Switch Profile</MenuItem>
                          </Menu>
                        )}
                      <Typography className={classes.actionText}>{userData?.applicantName}</Typography>
                    </Paper>
                  </Box>
                </Box>
                <Divider sx={{ mx: { xs: '18px', ultraHD: '20px' }, color: '#F0EDF6' }} />
                <Box className={`${classes.childrenContainer} scrollbar-hide`}>{children}</Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      {openNotification && <NotificationDialog open={openNotification} handleClose={handleCloseNotificationDialog} onNotificationCountUpdate={handleNotificationCountUpdate} />}
    </>
  );
};

export default AppLayout;
